export default __webpack_public_path__ + "static/media/2091-01.5957dcc6.jpg";